"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
module.exports = angular.module('backstage.components.common.users-event-picker', []).component('bsUsersEventPicker', {
  templateUrl: '/src/angular/components/common/users-event-picker/users-event-picker.html',
  bindings: {
    event: '<',
    events: '<',
    required: '<',
    emptyLabel: '<',
    onChange: '&'
  },
  controller: /*#__PURE__*/function () {
    UsersEventPicker.$inject = ["EventEmitter"];
    /* @ngInject */
    function UsersEventPicker(EventEmitter) {
      _classCallCheck(this, UsersEventPicker);
      this.EventEmitter = EventEmitter;
    }
    _createClass(UsersEventPicker, [{
      key: "$onInit",
      value: function $onInit() {
        return this.model = this.event;
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(_ref) {
        var event = _ref.event;
        if (event) {
          return this.model = this.event;
        }
      }
    }, {
      key: "update",
      value: function update() {
        return this.onChange(this.EventEmitter({
          eventId: this.model
        }));
      }
    }]);
    return UsersEventPicker;
  }()
}).name;